import { AiFillStar } from "react-icons/ai";
import { FaChevronRight } from "react-icons/fa";
import RatingsBar from "./RatingsBar";
import Image from "next/image";

const Review = () => {
	return (
		<>
			<div className='review-container overflow-hidden '>
				<div className='review-wrapper  '>
					<div className='review-section'>
						<div className='review-top'>
							<div className='review-avatar'>
								<Image
									src='/assets/images/girl.jpg'
									className=' rounded-lg '
									alt='brandlogo'
									loading='lazy'
									width={40}
									height={40}
								/>
							</div>
							<div className='review-details'>
								<p className='review-name'>Sierra</p>
								<p className='review-date'>April 2023</p>
							</div>
						</div>
						<div className='review-bottom'>
							<p className='review-comment'>
								I recently tried out this AI-powered cover letter generation
								SaaS, and it blew my mind! Crafting cover letters used to be a
								tedious task for me, but with this tool, it became a breeze.The
								result? A cover letter that landed me an interview within days.
							</p>
							<a href='#' className='rating-show'>
								Show more <FaChevronRight className='rating-icon--show' />
							</a>
						</div>
					</div>
					<div className='review-section'>
						<div className='review-top'>
							<div className='review-avatar'>
								<Image
									src='/assets/images/person1.jpg'
									className=' rounded-lg '
									alt='brandlogo'
									loading='lazy'
									width={40}
									height={40}
								/>{" "}
							</div>
							<div className='review-details'>
								<p className='review-name'>Sierra</p>
								<p className='review-date'>October 2023</p>
							</div>
						</div>
						<div className='review-bottom'>
							<p className='review-comment'>
								Simplified my cover letter woes! The AI adapts well, saving time
								and ensuring my letters stand out. A solid tool with room for
								minor tweaks.
							</p>
							<a href='#' className='rating-show'>
								Show more <FaChevronRight className='rating-icon--show' />
							</a>
						</div>
					</div>
					<div className='review-section'>
						<div className='review-top'>
							<div className='review-avatar'>
								<Image
									src='/assets/images/person2.jpg'
									className=' rounded-lg '
									alt='brandlogo'
									loading='lazy'
									width={40}
									height={40}
								/>{" "}
							</div>
							<div className='review-details'>
								<p className='review-name'>Sierra</p>
								<p className='review-date'>May 2023</p>
							</div>
						</div>
						<div className='review-bottom'>
							<p className='review-comment'>
								Unbelievably efficient! This AI-powered cover letter tool
								transformed my job application game. Tailored letters, quick
								results – a must-have for any job seeker.
							</p>
						</div>
					</div>
					<div className='review-section'>
						<div className='review-top'>
							<div className='review-avatar'>
								<Image
									src='/assets/images/person3.jpg'
									className=' rounded-lg '
									alt='brandlogo'
									loading='lazy'
									width={40}
									height={40}
								/>{" "}
							</div>
							<div className='review-details'>
								<p className='review-name'>Sierra</p>
								<p className='review-date'>November 2023</p>
							</div>
						</div>
						<div className='review-bottom'>
							<p className='review-comment'>
								Smart move for job seekers! The AI understands your profile,
								delivering quick and tailored cover letters. A handy tool with a
								bit of room for enhancement.
							</p>
						</div>
					</div>
				</div>

				<div className='line-rule' />
			</div>
		</>
	);
};

export default Review;
